import routerOptions0 from "/home/forge/cryptoteam.farbcode.net/releases/20260714121959/client/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}